import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import NavBar from "../navigations/NavBar";

// Renders children when used as a wrapper (<Layout><Page /></Layout>).
// Renders <Outlet /> when used as a layout route element (<Route element={<Layout />}>).
const Layout = ({ children }) => {
  return (
    <div className="flex-container">
      <Header />
      <NavBar />
      <div className="container mx-auto p-4">{children ?? <Outlet />}</div>
      <Footer />
    </div>
  );
};

export default Layout;
